import React from 'react'
import { useSetActiveModal } from 'src/Modal/ModalStateContext'
import { BasicDropdownMenuItem } from 'src/components/Reusable/BasicDropdown/BasicDropdown.styles'
import { ModalFormId } from '../../../../components/ModalForms'

export const DeleteAudit = (): JSX.Element => {
  const openDeleteAuditModal = useSetActiveModal(ModalFormId.DELETE_AUDIT)
  return (
    <BasicDropdownMenuItem
      eventKey="Close Audit"
      onClick={(e: React.MouseEvent) => {
        e.preventDefault()
        openDeleteAuditModal()
      }}
    >
      Delete Audit
    </BasicDropdownMenuItem>
  )
}
